export default __webpack_public_path__ + "static/media/CardSauna.2280635f.jpg";